module.exports = __webpack_public_path__ + "static/img/city-red-ar.d0624d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/red-about/city-red-ar.png
// module id = 1232
// module chunks = 4